
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-owners",
      function () {
        return require("private-next-pages/for-owners.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for-owners"])
      });
    }
  